import { ReactNode } from 'react'

export const StepButtonsWrapper = ({ children }: { children: ReactNode }) => (
  <div className='h-22 relative flex w-full items-start p-6 shadow ring ring-1 ring-slate-200'>
    <div className='stretch flex w-full justify-between space-x-2'>{children}</div>
  </div>
)
